import { style } from '@react-spectrum/s2/style' with { type: 'macro' }

export const fullWidthStyles = style({
  width: 'full',
})

export const fullWidthButtonStyles = style({
  width: 'full',
})

export const centeredButtonStyles = style({
  alignItems: 'center',
  justifyContent: 'center',
})

export const fullWidthCenteredButtonStyles = style({
  width: 'full',
  alignItems: 'center',
  justifyContent: 'center',
})

export const fullWidthStartButtonStyles = style({
  width: 'full',
  justifyContent: 'start',
})

export const fullWidthFlexButtonStyles = style({
  width: 'full',
  flexGrow: 1,
})

export const flexGrowButtonStyles = style({
  flexGrow: 1,
})

export const settingsTabListStyles = style({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  marginBottom: 32,
  width: 'full',
})

export const statusBadgeStyles = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
})

export const accountMenuStyles = style({
  width: 224,
})

export const artifactPreviewDialogStyles = style({
  maxHeight: '92vh',
  maxWidth: '96vw',
  overflow: 'hidden',
  padding: 0,
  width: 1180,
  zIndex: 60,
})

export const fullWidthDropZoneStyles = style({
  width: 'full',
})
